import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="text"
export default class extends Controller {
  static targets = ["textToCopy", "copyButton"];

  declare textToCopyTarget: HTMLElement;
  declare hasTextToCopyTarget: boolean;
  declare copyButtonTarget: HTMLElement;
  declare hasCopyButtonTarget: boolean;

  connect() {}

  async copy() {
    if (!this.hasTextToCopyTarget || !window.isSecureContext) return;
    try {
      await navigator.clipboard.writeText(this.textToCopyTarget.innerText);
      if (!this.hasCopyButtonTarget) return;
      this.copyButtonTarget.innerText = "Copié !";
      return true;
    } catch (error) {
      console.log(error);
      return false;
    }
  }
}
